<template>
  <div
    id="asc-content-wrapper"
    class="asc-content-wrapper"
    data-automation-id="wrapper_content"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AscContentWrapper',
}
</script>

<style lang="scss">
.asc-content-wrapper {
  // min-width: 500px; // Keep it as this was restricting to fit into mobile or xs devices
  height: calc(100vh - 84px);
  overflow-y: auto;
  background-color: $gray-100;
}
</style>
